import { Events } from '~/lib/events'

export default ({ app, $bus }) => {
  app.router.onReady(() => {
    $bus.$emit(Events.AppVisit)
    $bus.$emit(Events.PageViewed)
  })
}
